// ==========================================================================
// Vendor JS Bundle - New Orchards
// ==========================================================================
// This is the single vendor JS entry point. Webpack bundles this into
// dist/js/vendor.min.js which includes all third-party runtime dependencies.
//
// jQuery must be a window global because:
//   - jquery-validation-unobtrusive (ASP.NET form validation) expects it
//   - Bootstrap 4.x jQuery plugins may still be referenced in legacy pages
// ==========================================================================

// jQuery - expose as window global for jquery-validation-unobtrusive
const jQuery = require('jquery');
window.jQuery = jQuery;
window.$ = jQuery;

// Bootstrap 5 JS bundle (includes Popper.js)
// Exposed as a window global so page-specific scripts (separate Webpack entries)
// can use Bootstrap's programmatic API (e.g. bootstrap.Modal, bootstrap.Tooltip).
window.bootstrap = require('bootstrap');

// Print.js - PDF/HTML/Image printing
require('print-js');
